import { IconBase } from './iconBase';

import { CustomIconsProp } from '../types';

export const KornFerry = ({ size, color, className }: CustomIconsProp) => (
  <IconBase className={className} viewBox={256} size={size}>
    <rect width="256" height="256" rx="24" fill={color || '#094838'} />
    <svg x="8" y="8" width="240" height="240" viewBox="37 50.1 266.1 240">
      <g fill="#FFFFFF">
        <polygon points="168.3 268.9 109.4 268.9 37 165 118.2 71.3 146.3 71.3 146.3 81.4 122.7 81.4 70.3 142.5 151.5 258.7 168.3 258.7 168.3 268.9" />
        <rect x="177.1" y="50.1" width="9.7" height="240" />
        <path d="M259.8,213.5h-9.1l-.3-3.3c-.9-10.9-3-36.5-41.3-36.5h-3.6v-10.2h3.6c27.4,0,39-10,41.3-35.7l.3-3.3h9.1v89.1Z" />
        <path d="M303.1,139.7h-8.6l-.6-2.8c-8.4-37.3-28.5-55.5-61.7-55.5h-26.6v-10.2h97.6v68.4Z" />
      </g>
    </svg>
  </IconBase>
);
